import { useEffect } from "react";

import { useCall } from "@/hooks/useCall/useCall";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";
import { useTrack } from "@/hooks/useTrack/useTrack";
import { useBaseStore } from "@/store/store";

export function useTracking() {
  const { track } = useTrack();

  const { call } = useCall();
  const { line } = useGetLine();

  const evaluationTabSource = useBaseStore(
    (store) => store.evaluationTabSource
  );
  const shouldTrackEvaluationTabSource = useBaseStore(
    (store) => store.shouldTrackEvaluationTabSource
  );

  useEffect(() => {
    if (!shouldTrackEvaluationTabSource) {
      return;
    }

    track("conversation_evaluation_tab_opened", {
      call_uuid: call?.uuid,
      number_id: Number(line?.ID),
      evaluation_state: "default",
      from_source:
        evaluationTabSource === "insights_cta" ? "from_insights_cta" : "other",
    });
  }, [
    call?.uuid,
    evaluationTabSource,
    line?.ID,
    track,
    shouldTrackEvaluationTabSource,
  ]);
}
